// extracted by mini-css-extract-plugin
export default {"noDataMessage":"BookingHistory_noDataMessage__MndId","notFoundIcon":"BookingHistory_notFoundIcon__u0pW1","container":"BookingHistory_container__OpCBg"};